<template>
  <div class="progressbar">
    <div class="progressbar__label text-right">
      {{ label }}
    </div>
    <div class="progressbar__background">
      <div class="progressbar__progress" :style="{ width: progress + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progress: {
      default: 75
    },
    label: {
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.progressbar {
  &__label {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 9px;
  }

  &__background {
    background-color: #f2f2f2;
    border-radius: 10px;
    height: 10px;
  }

  &__progress {
    background-color: #f0c14b;
    border-radius: 10px;
    height: 10px;
  }
}
</style>
